import React, { useRef, useEffect, useState, useCallback } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { swapRateState } from "../../../context/swapRateState";
import { swapState } from "../../../context/swapState";
import { useConfig } from "../../../hooks/useConfig";

const Input = ({
  disabled,
  tokenName,
}: {
  disabled: boolean | undefined;
  tokenName: string;
}) => {
  const [val, setval] = useState("");
  const setSwapData = useSetRecoilState(swapState);
  const swapData = useRecoilValue(swapState);
  const swapRateData = useRecoilValue(swapRateState);
  const [assetPrice, setAssetPrice] = useState("");
  const { getAssetPrice } = useConfig();

  useEffect(() => {
    (async () => {
      const price = await getAssetPrice(tokenName);
      setAssetPrice(
        Number(
          Number(price) *
            Number(
              !disabled
                ? swapData.input1
                : swapData.input1
                ? swapRateData.input2
                : "0"
            )
        ).toFixed(5)
      );
    })();
  }, [tokenName, swapData.input1, swapRateData.input2]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      let input = val;
      if (Number(e.target.value) >= 0) input = e.target.value;
      setval(input);
      setSwapData({
        ...swapData,
        input1: input as string,
      });
      // setAssetPrice(Number(getAssetPrice(tokenName)) * Number(swapData.input1));
    }
  };

  const refInput = useCallback(
    (inputElement: any) => {
      if (inputElement) {
        inputElement.focus();
      }
    },
    [swapData.input1]
  );

  return (
    <div className="input-container">
      <input
        disabled={disabled}
        placeholder="0.00"
        onChange={handleInputChange}
        value={
          !disabled
            ? swapData.input1
            : swapData.input1
            ? Number(swapRateData.input2).toFixed(4)
            : ""
        }
        autoFocus={!disabled ? true : false}
        ref={refInput}
      />
      <div className="input-container-price">${assetPrice}</div>
    </div>
  );
};

export default Input;
